import { css } from 'styled-components';
// sm, md, lg, xl
export const breakpoints = [576, 768, 992, 1200];
export const mediaqueryBreakpoints = {
  sm: breakpoints[0],
  md: breakpoints[1],
  lg: breakpoints[2],
  xl: breakpoints[3],
};
const MediaQuery = {
  extraSmall: (...args) => css`
    @media only screen and (max-width: ${mediaqueryBreakpoints.sm}px) {
      ${css(...args)};
    }
  `,
  small: (...args) => css`
    @media only screen and (min-width: ${mediaqueryBreakpoints.sm}px) {
      ${css(...args)};
    }
  `,
  medium: (...args) => css`
    @media only screen and (min-width: ${mediaqueryBreakpoints.md}px) {
      ${css(...args)};
    }
  `,
  large: (...args) => css`
    @media only screen and (min-width: ${mediaqueryBreakpoints.lg}px) {
      ${css(...args)};
    }
  `,
  extraLarge: (...args) => css`
    @media only screen and (min-width: ${mediaqueryBreakpoints.xl}px) {
      ${css(...args)};
    }
  `,
};

export default MediaQuery;
